export const questions = [
    {
        "key": "ownerName",
        "question": "Owner Name"
    },
    {
        "key":"dob",
        "question": "Date of Birth"
    },
    {
        "key":"email",
        "question": "Email"
    },
    {
         "key":"phone",
        "question": "Phone Number"
    },
    {
        "key":"abnNumber",
        "question": "Abn Number"
    },
    
    {"key":"companyName","question":"Company Name"},
    {
        "key":"certificateOfIncorporation",
        "question": "Certificate Of Incorporation "
    },
    {
        "key":"address",
        "question": "address"
    },
    {
        "key": "registrationPaper",
        "question": "Registration Paper"
    },
    {
        "key":"registrationPaperExpiry",
        "question": "Registration Paper Expiry"
    },
    {
        "key":"vehicleInsurance",
        "question": "Vehicle Insurance"
    },
    {
         "key":"vehicleInsuranceExpiry",
        "question": "Vehicle Insurance Expiry"
    }, 
    {
        "key": "cameraCertificate",
        "question": "Camera Certificate"
    },
    {
        "key": "cameraCertificateExpiry",
        "question": "Camera Certificate Expiry"
    },
    {
        "key":"licensePhoto",
        "question": "license Photo"
    },
    {
        "key":"licensePhotoExpiry",
        "question": "License Photo Expiry"
    },
    {
         "key":"pinkSlip",
        "question": "Pink Slip"
    },{
        "key":"pinkSlipExpiry",
        "question": "PinkSlip Expiry"
    },
    {
         "key":"driversLicense",
        "question": "Drivers License"
    }, {
        "key": "driversLicenseExpiry",
        "question": "Drivers License Expiry"
    },
    {
        "key":"bankName",
        "question": "Bank Name"
    },
    {
        "key":"branchName",
        "question": "Branch Name"
    },{
        "key":"bsbNumber",
        "question": "BSB Number"
    },
    {
         "key":"accountNumber",
        "question": "Account Number"
    }, {
        "key": "notes",
        "question": "Notes"
    },
    {
        "key":"acceptTerms",
        "question": " I accept all the terms and conditions and confirm that all information provided is accurate and complete."
    },
    {
        "key":"createdAt",
        "question": " Submission Date"    }

]